<section class="flex-1 flex flex-col bg-white min-h-0 min-w-0 overflow-hidden">

    <div class="flex items-center justify-between mb-2.5 px-5 py-4 bg-gradient-to-br from-white to-[#f8f9fa] border-b-2 border-[#e8eaed] shadow-[0_2px_4px_rgba(0,0,0,0.04)] gap-4">
      <a routerLink="/dashboard" class="inline-flex items-center gap-1 px-4 py-2 rounded-[4px] font-medium bg-[#F99C1E] text-white cursor-pointer transition-colors text-sm hover:bg-[#172C41]"
      *appHasRole="['STK_MEMBER', 'STK_ADMINISTRATION']">Ir a Road Sentinel</a>
    </div>

    @if (statusMessage(); as message) {
        <div [class]="'fixed top-4 right-4 z-50 px-4 py-3 rounded-[4px] shadow-lg text-sm font-medium ' + (message.type === 'success' ? 'bg-green-100 text-green-800 border border-green-300' : 'bg-red-100 text-red-800 border border-red-300')">
            {{ message.text }}
        </div>
    }

    <div class="grid grid-cols-1 md:grid-cols-1 mb-10">
        <div>
            <app-beacon-filters 
                (filtersApplied)="onFiltersApplied($event)">
            </app-beacon-filters>
        </div>
    </div>
    <div class="grid grid-cols-1 md:grid-cols-2 gap-10">
        <div>
            <app-beacon-table 
                [isLoading]="isLoading()"
                [beacons]="beacons()"
                [currentFilters]="currentFilters()"
                [totalRecords]="totalRecords()"
                [first]="first()"
                [rows]="rows()"
                (filters)="onFiltersApplied($event)"
                (selectBeacon)="onSelectedBeacon($event)"
                (beaconUpdated)="onBeaconUpdated()"
            >
            </app-beacon-table>
        </div>
        <div>
            <mgl-map
            [mapStyle]="'https://tiles.openfreemap.org/styles/bright'"
            [zoom]="[3]"
            [center]="[-99.133269155658, 19.42879288402023]"
            class="w-full h-[65vh]"
            (mapLoad)="onMapLoad($event)"
            >
                @for (beacon of mapBeacons(); track beacon.id) {
                    @if (beacon.latitude != null && beacon.longitude != null) {
                        <mgl-marker #beaconMarker [lngLat]="[beacon.longitude, beacon.latitude]">
                            <div class="size-6 rounded-full bg-[#F99C1E] border-2 border-white shadow-md cursor-pointer" 
                            [class]="{
                                'bg-red-600': beacon.trackingEnabled 
                            }"></div>
                        </mgl-marker>
                        <mgl-popup [marker]="beaconMarker" [closeButton]="true" [closeOnClick]="false">
                            <div class="text-sm p-1">
                                <div class="font-semibold text-[#172C41]">{{ beacon.macAddress }}</div>
                                <div class="text-gray-600">{{ beacon.vin }} / {{ beacon.assetName }} / {{ beacon.holderName }}</div>
                                <div class="text-gray-500">{{ formatDate(beacon.reportDate) }}</div>
                                <div class="text-gray-500">{{ timeWithoutReporting(beacon) }}</div>
                            </div>
                        </mgl-popup>
                    }
                }
            </mgl-map>
        </div>
    </div>
</section>
